import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Error = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 16 16"
    >
      <path
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill="#D43434"
      />
      <path
        d="M11.7676 11.7676C11.458 12.0773 10.9418 12.0773 10.6321 11.7676L7.99988 9.13537L5.36762 11.7676C5.05795 12.0773 4.54179 12.0773 4.23213 11.7676C3.92246 11.458 3.92246 10.9418 4.23213 10.6321L6.86439 7.99988L4.23213 5.36762C3.92246 5.05795 3.92246 4.54179 4.23213 4.23213C4.54179 3.92246 5.05795 3.92246 5.36762 4.23213L7.99988 6.86439L10.6321 4.23213C10.9418 3.92246 11.458 3.92246 11.7676 4.23213C12.0773 4.54179 12.0773 5.05795 11.7676 5.36762L9.13537 7.99988L11.7676 10.6321C12.0773 10.9418 12.0773 11.4579 11.7676 11.7676Z"
        fill="white"
      />
    </SvgIcon>
  ))
);

export default Error;
